<div class="mt-3 box-upload">
  <div class="file-chooser-wrapper">
    <div class="file-chooser-label">
      {{ title! | translate }}
      <span *ngIf="required"
            class="required-asterisk">*</span>
    </div>
    <div class="upload-container">
      <!-- Upload Area and Files in Same Row -->
      <div class="upload-row">
        <!-- Compact Upload Area -->
        <div
          (dragleave)="onDragLeave($event)"
          (dragover)="onDragOver($event)"
          (drop)="onFileDropped($event)"
          [class.disabled]="disabled"
          [class.drag-over]="isDragOver"
          class="parent-file-chooser"
        >
          @if (isMultiple) {
            <input
              (change)="fileBrowseHandler($event)"
              [accept]="accept"
              [disabled]="disabled"
              class="file-input"
              multiple
              onclick="this.value=null;"
              type="file"
            />
          } @else {
            <input
              (change)="fileBrowseHandler($event)"
              [accept]="accept"
              [disabled]="disabled"
              class="file-input"
              onclick="this.value=null;"
              type="file"
            />
          }

          <div class="upload-content">
            <div class="upload-icon">
              <mat-icon class="upload-icon-svg">cloud_upload</mat-icon>
            </div>
            <div class="upload-text">
              <span class="upload-title">{{ 'DragFilesHere' | translate }}</span>
              <span class="upload-subtitle">{{ 'OrClickToSelect' | translate }}</span>
            </div>
          </div>
        </div>
        <!-- Selected Files Display -->
        @if (files && files.length > 0) {
          <div class="selected-files">
            <div class="files-header">
              <span class="files-count">
                <mat-icon class="files-count-icon">folder_open</mat-icon>
                {{ files.length }} {{ 'SelectedFiles' | translate }}
              </span>
            </div>
            <div class="files-list">
              @for (file of files; track $index) {
                <div class="file-item-compact">
                  <div class="file-preview-compact">
                    @if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(getFileType(file))) {
                      <img
                        [alt]="file.name"
                        [src]="getImageSrc(file)"
                        class="preview-image-compact"
                      />
                    } @else {
                      <div class="file-icon-compact">
                        <mat-icon class="file-type-icon-compact">{{ getFileIcon(file) }}</mat-icon>
                      </div>
                    }
                    <div class="file-overlay-compact">
                      <button (click)="onFileClicked($index)"
                              [title]="'ViewFile' | translate"
                              class="btn-view-compact"
                              mat-icon-button>
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <button (click)="deleteFile($index)"
                              [title]="'DeleteFile' | translate"
                              class="btn-delete-compact"
                              mat-icon-button>
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div class="file-info-compact">
                    <span [title]="file.name"
                          class="file-name-compact">{{ file.name }}</span>
                    <span class="file-size-compact">{{ getFileSize(file) }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (required && (!files || files.length === 0)) {
      <div class="error-message">{{ 'IsFieldRequired' | translate }}</div>
    }
  </div>
</div>
